import { isSuccess } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { contactService } from "../../shared/api/contactService";
import { IContactUpdateResource, TagIndexResource } from "../../shared/types";
import { ViewTagsSection } from "../../shared/view";

interface Props {
	contact: IContactUpdateResource;
}

export const ContactViewTagsSection: FC<Props> = ({ contact }) => {
	const queryClient = useQueryClient();

	const handleUpdateTags = async (tags: TagIndexResource[]) => {
		const response = await contactService.updateTags(
			contact.id,
			tags.map((x) => x.id),
		);
		await queryClient.invalidateQueries({ queryKey: contactService.showKey(contact.id) });
		await queryClient.invalidateQueries({ queryKey: contactService.listKey });
		return isSuccess(response);
	};

	return <ViewTagsSection tags={contact.tags} onUpdateTags={handleUpdateTags} />;
};
